import React ,{ useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Card, Typography, Button } from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { useDispatch, useSelector } from "react-redux";
import { preAfiliacionesTomadasLimpiar, fetchPreAfilicionesTomadasPorUsuario, liberarPreAfiliacion } from "../../actions/preafiliacionesTomadas";

const useStyles = makeStyles({
  card: {
    padding: 20,
    height: 200,
    width: 800,
    marginTop: 50,
    marginBottom: 20,
  },
  tableTitle: {
    marginBottom: 15,
  },
  button: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

export const InicioAfiliaciones = () => {
  
    const classes = useStyles();
    const dispatch = useDispatch();

    const auth = useSelector((state)=>state.auth);
    const { itemsUsuario } = useSelector((state) => state.preAfiliacionesTomadas);

    useEffect(() => {
        dispatch( preAfiliacionesTomadasLimpiar() );
        dispatch( fetchPreAfilicionesTomadasPorUsuario( auth.idUsuario ) );
    }, [auth.idUsuario, dispatch]);

    const handleLiberarPreAfiliacion = id => {
        dispatch( liberarPreAfiliacion(id) );
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 70, hide: true },
        { field: 'idGrupoFamiliar', headerName: 'Grupo Familiar', width: 150 },
        { field: 'titular', headerName: 'Titular', width: 200 },
        { field: 'cuilTitular', headerName: 'Cuil', width: 130 },
        { 
          field: 'fechaTomada', 
          headerName: 'Fecha Tomada', 
          width: 165,
          renderCell: (params) => (
            new Date(params.getValue('fechaTomada')).toLocaleString(
              "es",
              optionsfecha
            )
          ),
        },
        { field: 'idUsuario', headerName: 'Id Usuario', width: 120, hide: true },
        { field: 'usuario', headerName: 'Usuario', width: 185, hide: true },
        { 
            field: 'action', 
            headerName: 'Accion', 
            width: 110,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <strong>
                    <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {handleLiberarPreAfiliacion(params.getValue('id'))}}
                    >
                    Liberar
                    </Button>
                </strong>
            ),
        }
    ];
      
    return (
      <div>
        {itemsUsuario.length > 0 && (
            <Grid> 
              <Grid container justify="center">
                  <Card className={classes.card} >
                      <Typography className={classes.tableTitle}>
                          <strong>PreAfiliacion Tomada</strong></Typography>
                      <DataGrid 
                          autoHeight 
                          rows={itemsUsuario} 
                          columns={columns} 
                          hideFooterPagination={true}
                          hideFooter={true}
                          disableColumnMenu={true}
                      />
                  </Card>
              </Grid>
          </Grid>
        )}
      </div>
    );

};
